import { useQuery } from '@tanstack/react-query';
import { fetchNavigationBadges } from '../../lib/api/navigationBadges';
import { queryKeys } from './queryKeys';

export type NavigationBadgeScope = {
  token: string | null;
  projectId: string;
  memberId: string | null;
  permissions: readonly string[];
  isAccessReady: boolean;
  enabled?: boolean;
};

export const useNavigationBadges = (scope: NavigationBadgeScope) => {
  const enabled =
    Boolean(scope.token && scope.projectId && scope.memberId) &&
    scope.isAccessReady &&
    scope.permissions.includes('project.enter') &&
    (scope.enabled ?? true);
  const query = useQuery({
    queryKey: queryKeys.navigationBadges.detail(scope.projectId, scope.memberId ?? '', scope.permissions),
    queryFn: () => fetchNavigationBadges(scope.token as string, scope.projectId),
    enabled,
    staleTime: 30_000,
  });

  // 권한 미판정·재조회 실패의 캐시 잔존값을 정상 집계로 표시하지 않는다.
  return { ...query, data: enabled && query.isSuccess ? query.data : undefined };
};
